import _MenuItem from "@material-ui/core/esm/MenuItem";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import Select from '../styled-select/styled-select';
import classes from './giveaway-product-size-select.scss';
export class GiveawayProductSizeSelect extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClick", value => e => {
      const {
        showSelection,
        onChange
      } = this.props;
      if (showSelection) {
        e.stopPropagation();
      }
      onChange(value || e.target.value);
    });
    _defineProperty(this, "isAvailableVariant", index => {
      const {
        selectedColors,
        product: {
          variants
        },
        isReserve
      } = this.props;
      let variant;
      if (!isReserve) {
        return true;
      }
      if (selectedColors && selectedColors.length > 0) {
        variant = variants.find(variant => selectedColors.includes(variant.colorValue) && variant.sizeIndex === index);
      } else {
        variant = variants.find(variant => variant.sizeIndex === index);
      }
      return variant && variant.inProductionQuantity + variant.quantity - variant.inReserveQuantity > 0;
    });
  }
  render() {
    const {
      sizes,
      primaryColor,
      selectedSize,
      selectable,
      showSelection
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.sizesBlock, {
        [classes.inlineSizesBlock]: selectable
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.text, {
        [classes.inlineText]: selectable
      })
    }, "What size would you like?"), /*#__PURE__*/React.createElement("div", {
      className: classes.sizesWrapper
    }, sizes.map((size, index) => /*#__PURE__*/React.createElement("div", {
      "data-size-name": size,
      className: classnames(classes.sizeButton, {
        [classes.selected]: selectedSize === size && showSelection,
        [classes.disabled]: !this.isAvailableVariant(index)
      }),
      key: size,
      style: selectedSize === size && showSelection ? {
        borderColor: primaryColor
      } : {},
      onClick: this.isAvailableVariant(index) ? this.handleClick(size) : () => undefined
    }, size))), /*#__PURE__*/React.createElement("div", {
      className: classes.sizesSelect
    }, /*#__PURE__*/React.createElement(Select, {
      onChange: this.handleClick(null),
      value: selectedSize,
      displayEmpty: true,
      fullWidth: true
    }, /*#__PURE__*/React.createElement(_MenuItem, {
      value: "",
      disabled: true
    }, "Select a size*"), sizes.map((size, index) => {
      if (this.isAvailableVariant(index)) {
        return /*#__PURE__*/React.createElement(_MenuItem, {
          value: size,
          key: size
        }, size);
      }
    }))));
  }
}